import type { Logger } from "@expert/logging";

import { useChatExpertAssistSessions } from "./useChatExpertAssistSessions";
import { useGaiaMessageEvents } from "./useGaiaMessageEvents";

export const useSetupSubscriptions = (logger: Logger) => {
    useGaiaMessageEvents(logger);
};

export const useSetupChatGaiaSubscriptions = (logger: Logger) => {
    useGaiaMessageEvents(logger);
    useChatExpertAssistSessions(logger);
};
